<template>
  <div
    class="question-container"
    :style="{
      border:
        dataObj.status === 1
          ? '1px dashed rgba(58,96,255,1)'
          : '1px solid #EDEFF2',
      padding: '3px 12.5px', // 6rpx 25rpx → 3px 12.5px
    }"
  >
    <div class="title-view">
      <!-- <span>{{ caseProblem }}</span> -->
      <div v-html="dataObj.caseProblem" class="rich-text-content"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "QuestionTitleView",
  // Vue2 定义 props
  props: {
    params: {
      type: Object,
      default: () => ({}), // 避免对象引用问题
    },
    index: {
      type: Number,
      default: 0,
    },
    updateType: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      caseProblem: "",
      dataObj: {},
    };
  },
  // Vue2 监听属性
  watch: {
    // 监听 props.dataObj 变化
    params: {
      handler(newValue) {
        console.log("mnwefwegwfwegfewfweifiuwefiew", newValue);
        // 保持原逻辑：取 newValue.data 下的字段
        this.caseProblem = newValue.data.caseProblem;
        this.dataObj = newValue.data;
      },
      immediate: true, // 初始加载触发
      deep: true, // 深度监听对象内部变化
    },
  },
};
</script>

<style lang="scss" scoped>
.question-container {
  box-sizing: border-box;
}

.title-view {
  width: 100%;
  background: #ffffff;
  font-size: 16px;
  font-weight: 600;
  text-align: left;
  color: #2b2f36;
  padding: 5px 0;
  position: relative;
  justify-content: flex-start;

  &::before {
    display: block;
    content: "";
    width: 4px;
    height: 15px;
    background-color: #3a60ff;
    margin-right: 10px;
    margin-top: 3px;
    border-radius: 0 4px 4px 0;
  }

  span {
    flex: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/QuestionPreview/QuestionPreviewTitle.vue